import {Image} from '@/_application/core/components/ui/image';
import {getProductUrl, Product} from '@/_application/modules/products/model/product';
import {productPlaceholder} from '@/lib/placeholders';
import Link from 'next/link';
import {useCalculatePrices} from '@/_application/modules/products/components/price/calculate-prices';

interface IProductCrossSellItem {
    item: Product;
    handleCheckboxChange: (productId: number) => void;
    isChecked: boolean;
    showPlus?: boolean;
}

const ProductCrossSellItem = ({item, handleCheckboxChange, isChecked, showPlus = true}: IProductCrossSellItem) => {
    const {price, basePrice} = useCalculatePrices(item);
    const productImage = getProductUrl(item);
    return (
        <div className="flex h-full items-center gap-1.5">
            <div className="mx-1 h-40.25 rounded-[10px] bg-white px-5 py-3 shadow-[2px_2px_8px_0px_#00000026]">
                <div className="grid h-full w-full grid-cols-3 gap-2">
                    <Link href={productImage} className="col-span-1 block">
                        <Image
                            src={item?.small_image?.url ?? productPlaceholder}
                            alt={item.name ?? 'Product'}
                            width={96}
                            height={96}
                            className="h-full! w-full! object-contain"
                        />
                    </Link>

                    <div className="col-span-2 flex flex-col justify-between">
                        <Link
                            href={productImage}
                            className="line-clamp-2 text-sm text-KPZ_text_1st transition-colors hover:text-primary">
                            {item.name}
                        </Link>
                        <div className="flex flex-row items-end gap-x-5 gap-y-0 xl:flex-row xl:items-end">
                            <div className="flex flex-col">
                                <p className="text-xl font-bold text-KPZ_Orange">{price}</p>
                                <p className="text-sm text-KPZ_text_2nd line-through">{basePrice}</p>
                            </div>

                            <div className="cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="cursor-pointer accent-primary"
                                    onChange={() => handleCheckboxChange(item.id!)}
                                    checked={isChecked}
                                    aria-label="Select Product Checkbox"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showPlus && <span className="text-3xl font-extrabold text-primary">+</span>}
        </div>
    );
};

export default ProductCrossSellItem;
